// extracted by mini-css-extract-plugin
export default {"title":"XPGS1o","accepted-payment-method-icon":"qb4lnP","acceptedPaymentMethodIcon":"qb4lnP","payment-method-logo":"BjPYks","paymentMethodLogo":"BjPYks"};